var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM5.5 9.965C3.525 9.72 2 8.04 2 6C2 5.69 2.04 5.395 2.105 5.105L4.5 7.5V8C4.5 8.55 4.95 9 5.5 9V9.965ZM8.95 8.695C8.82 8.29 8.45 8 8 8H7.5V6.5C7.5 6.225 7.275 6 7 6H4V5H5C5.275 5 5.5 4.775 5.5 4.5V3.5H6.5C7.05 3.5 7.5 3.05 7.5 2.5V2.295C8.965 2.89 10 4.325 10 6C10 7.04 9.6 7.985 8.95 8.695Z",
    fill: "#BFBBCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobe);
export default __webpack_public_path__ + "static/media/icon-globe.70bfa06968c48e050073077ee8c7e7f7.svg";
export { ForwardRef as ReactComponent };